const actions = {
  SET_STATE: 'orderhistory/SET_STATE',
  GET_ORDERS: 'orderhistory/GET_ORDERS',
  GET_ORDER_DETAILS: 'orderhistory/GET_ORDER_DETAILS',
  GET_FUTURE_ORDERS: 'orderhistory/GET_FUTURE_ORDERS',
  CANCEL_ORDER: 'order/CANCEL_ORDER',
  UPDATE_ORDER_ADDRESS: 'order/UPDATE_ORDER_ADDRESS',
  UPDATE_ORDER_TIME: 'order/UPDATE_ORDER_TIME',
  CANCEL_DELIVERY: 'order/CANCEL_DELIVERY',
  CREATE_DELIVERY: 'order/CREATE_DELIVERY',
}

export default actions
